<div>
  <div class="flex justify-between relative flex-col">
    <div class="toolbar bg-primary flex items-center justify-between px-1">
      <mat-tab-group
        (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="currentTab"
        class="users-tabs"
      >
        <mat-tab label="ACTIVE QUOTES"></mat-tab>
        <mat-tab label="ARCHIVED QUOTES"></mat-tab>
      </mat-tab-group>
      <mat-form-field>
        <mat-label class="text-white text-sm">Search quotes</mat-label>
        <input matInput [formControl]="searchControl" />
      </mat-form-field>
    </div>
    <div class="filters-container flex gap-4 py-4">
      <mat-form-field class="flex-1">
        <mat-label>Filter by Client</mat-label>
        <input
          type="text"
          matInput
          [formControl]="clientFilterControl"
          [matAutocomplete]="auto"
          (click)="clientFilterControl.setValue(clientFilterControl.value)"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          @for (customer of filteredOptions$ | async; let i = $index; track i) {
            <mat-option [value]="customer">
              {{ customer.firstName }} {{ customer.lastName }}, #{{ customer.customerCode }},
              {{ customer.company }},
              {{ customer.customerState }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Filter by Status</mat-label>
        <mat-select [formControl]="statusFilterControl">
          @for (option of statuses(); track option.key) {
            @if (option.key !== 'IN_PRODUCTION') {
              <mat-option [value]="option.key">{{ option.value }}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex-1">
        <mat-label>Filter by Assignee</mat-label>
        <mat-select [formControl]="assigneeFilterControl">
          @for (option of assignees(); track option.id) {
            <mat-option [value]="option.id"
              >{{ option.firstName }} {{ option.lastName }}</mat-option
            >
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex justify-end gap-2 pb-4">
      <button mat-flat-button color="primary" (click)="onClearFilters()">Clear Filters</button>
      <button mat-flat-button color="accent" routerLink="add">Add Quote +</button>
    </div>
  </div>

  <router-outlet></router-outlet>
</div>
